import { useContext } from "react";
import WebplaceContext from "../../../store/webplace-context";

import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TikTok from "../../../assets/mainItems/tiktokLogo.svg";
import PoweredHubster from "../../../assets/mainItems/poweredHubster.svg";
import PoweredOtter from "../../../assets/mainItems/poweredOtter.svg";

import "./Footer.css";

const splitString = (data) => {
  return data.split("/");
};

const Footer = () => {
  const footerLocationsCtx =
    useContext(WebplaceContext).locationInformation.locations;
  const footerInfoCtx = useContext(WebplaceContext).footerInformation;
  const contactCtx = useContext(WebplaceContext).homeSocials;
  const stylesCtx = useContext(WebplaceContext).footerInformation.footer_styles;

  const address = splitString(footerLocationsCtx[0].address);
  const schedule = splitString(footerLocationsCtx[0].schedule);
  const phone = footerLocationsCtx[0].phone;
  let poweredBy;

  if (footerInfoCtx.powered_by_hubster === footerInfoCtx.powered_by_otter) {
    poweredBy = <></>;
  } else if (
    footerInfoCtx.powered_by_hubster &&
    !footerInfoCtx.powered_by_otter
  ) {
    poweredBy = (
      <img src={PoweredHubster} alt="Powered by" className="lower-footer-powered" />
    );
  } else {
    poweredBy = (
      <img src={PoweredOtter} alt="Powered by" className="lower-footer-powered" />
    );
  }

  const socialsArr = [
    { appName: "etsy", url: "https://www.etsy.com/people/nu7nluaryvkfefgp?ref=hdr_user_menu-profile" },
    { appName: "yelp", url: "https://www.yelp.com/biz/debs-delights-los-angeles-5" },
    { appName: "twitter", url: "https://twitter.com/gam44537" }
  ]

  const currentYear = new Date().getFullYear()

  return (
    <div
      className="footer-wrapper"
      style={{
        backgroundColor: stylesCtx.background_color,
        color: stylesCtx.subtitle_font_color,
      }}
      aria-label="footer"
    >
      <div className="footer-title" role="heading" aria-level="2">{footerInfoCtx.title}</div>
      <div className="footer-info-wrapper">
        {/* Locations and address */}
        {footerLocationsCtx.length === 1 && (
          <div className="info-wrapper">
            <div className="info-title" role="heading" aria-level="3">{footerInfoCtx.address_subtitle}</div>
            {address.map((data, index) => {
              return (
                <div
                  className="info-data"
                  style={{ color: stylesCtx.info_font_color }}
                  key={index}
                >
                  {data}
                </div>
              );
            })}
          </div>
        )}
        {footerLocationsCtx.length > 1 && (
          <div className="info-wrapper info-locations-footer">
            <div className="info-title" role="heading" aria-level="3">{footerInfoCtx.locations_subtitle}</div>
            {footerLocationsCtx.map((data, index) => {
              return (
                <div
                  className="info-data"
                  style={{ color: stylesCtx.info_font_color }}
                  key={index}
                >
                  {data.location_title}, {data.city}
                </div>
              );
            })}
          </div>
        )}

        {/* Schedule */}
        {footerLocationsCtx.length === 1 && (
          <div>
            <div className="info-title" role="heading" aria-level="3">{footerInfoCtx.hours_subtitle}</div>
            {schedule.map((data, index) => {
              return (
                <div
                  className="info-data"
                  style={{ color: stylesCtx.info_font_color }}
                  key={index}
                >
                  {data}
                </div>
              );
            })}
          </div>
        )}

        {/* Contact information */}
        {footerInfoCtx.show_contact_option && (
          <div>
            <div className="info-title" role="heading" aria-level="3">
              {footerInfoCtx.contact_info_subtitle}
            </div>
            {footerLocationsCtx.length === 1 && (
              <a
                className="info-data"
                style={{ color: stylesCtx.info_font_color }}
                href={`tel: ${phone}`}
              >
                <div
                  className="info-data"
                  style={{ color: stylesCtx.info_font_color }}
                >
                  {phone}
                </div>
              </a>
            )}
            <div
              className="info-data"
              style={{ color: stylesCtx.info_font_color }}
            >
              {contactCtx.contact_email}
            </div>
          </div>
        )}

        {/* Social media & powered by */}
        <div className="socials-powered-wrapper">
          <div className="social-media-wrapper">
            {contactCtx.instagram_url.length > 0 && (
              <div>
                <a
                  href={contactCtx.instagram_url}
                  target="_self"
                  rel="noopener noreferrer"
                  className="anchor-social"
                  aria-label="Visit our Instagram page"
                >
                  <InstagramIcon fontSize="inherit" />
                </a>
              </div>
            )}
            {contactCtx.facebook_url.length > 0 && (
              <div>
                <a
                  href={contactCtx.facebook_url}
                  target="_self"
                  rel="noopener noreferrer"
                  className="anchor-social"
                  aria-label="Visit our Facebook page"
                >
                  <FacebookIcon fontSize="inherit" />
                </a>
              </div>
            )}
            {contactCtx.tiktok_url.length > 0 && (
              <div>
                <a
                  href={contactCtx.tiktok_url}
                  target="_self"
                  rel="noopener noreferrer"
                  className="anchor-social"
                  aria-label="Visit our TikTok page"
                >
                  <img
                    src={TikTok}
                    alt="tiktok"
                    className="anchor-social-img"
                  />
                </a>
              </div>
            )}
            {socialsArr.map((data) => {
              return <div key={data.appName}>
                <a
                  href={data.url}
                  target="_self"
                  rel="noopener noreferrer"
                  className={data.appName === "etsy" ? "anchor-social-etsy" : "anchor-social"}
                  aria-label={`Visit our ${data.appName} page`}
                >
                  <img
                    src={require(`../../../assets/mainItems/${data.appName}.svg`)}
                    alt={data.appName}
                    className={data.appName === "etsy" ? "anchor-social-img-etsy" : "anchor-social-img"}
                  />
                </a>
              </div>
            })}
          </div>
        </div>

      </div>
      <div className="lower-footer-wrapper">
        <div className="corp-gifts-contact" aria-label="Contact corporate Gifts">To contact us for corporate gifts and catering contact orders@debbiesdinners.com, <a href="tel:323-936-4545" className="footer-phone">323-936-4545</a>.</div>
        {poweredBy}
      </div>

      <div className="copyright-wrapper">
        <div aria-label="Copyright text">
          Copyright (c) {currentYear} Debbies Dinners, Inc. dba Deb's Delights Bake Shop, Company, All Rights Reserved.  Use of this site is subject to certain Terms of Use: Copying, reusing or reproducing website content including artwork requires written pre-authorization from Debbies Dinners Inc.  Users of this website assume all risks from any injury and will hold Debbies Dinners Inc. and Deb's Delights Bake Shop, principles, employees and all associates, harmless.  Store prices may vary from those displayed.  Products shown as available are normally stocked but inventory levels cannot be guaranteed.
        </div>
      </div>
    </div>
  );
};

export default Footer;
